import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Api from '../../Components/Api.js';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import numeral from 'numeral';
import ReactPaginate from 'react-paginate';
import moment from 'moment';
import * as XLSX from 'xlsx';

UIkit.use(Icons);

export default class PackageList extends Component {
  state = {
    list: [],
    loadingApi: false,
    pageNow: 1,
    pageAmount: 1,
    perPage: 10
  }

  listGet = async  () => {
    this.setState({loadingApi: true});

    var _response = await Api.consult("M2PackageList", {
      page: this.state.pageNow
    });

    this.setState({
      list: _response.list || [],
      loadingApi: false,
      pageAmount: _response.pageAmount || 1
    });
  }

  getDisplayPrice = (data) => {
    var _price = numeral(data.price).format('0,0.00');

    if(data.price_type === 'multi') {
      try {
        var _price_array = JSON.parse(decodeURIComponent(data.price_array));

        var _price_low = Infinity;
        var _price_high = 0;

        for(var a of _price_array) {
          if(parseFloat(a.price) < _price_low) {
            _price_low = a.price;
          }

          if(parseFloat(a.price) > _price_high) {
            _price_high = a.price;
          }
        }

        if(_price_low === Infinity) {
          _price_low = 0;
        }
        
        _price = `${numeral(_price_low).format('0,0.00')} - ${numeral(_price_high).format('0,0.00')}`;
      } catch(e) {
        console.error(e);
      }
    }

    return _price;
  }

  CsvExport = async () => {


    var _response = await Api.consult("M2PackageList", {
      page: 'all'
    });



    if(!Array.isArray(_response.list) || _response.list.length === 0) {
      UIkit.notification({ message: 'ไม่มีรายการแพ็คเกจให้ดาวน์โหลด', status: 'warning' });
      return;
    }

    const header = ['ลำดับ','ชื่อแพ็คเกจ','ราคา','ใช้งาน','วันหมดอายุ'];
    const csvRows = [header];

    _response.list.forEach((data, key) => {
      const priceText = this.getDisplayPrice(data);
      const publishText = data.publish === '1' ? 'ใช้งาน' : 'ไม่ใช้งาน';
      const expiredText = data.expired_date && data.expired_date != '0000-00-00' ? moment(data.expired_date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';

      csvRows.push([
        (this.state.perPage * (this.state.pageNow-1 ) + key + 1).toString(),
        data.title || '',
        `฿ ${priceText}`,
        publishText,
        expiredText
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(csvRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'PackageList');
    XLSX.writeFile(wb, `package-list-${moment().format('YYYY-MM-DD_HHmmss')}.xlsx`);
  }

  
  handlePageClick = (page) => {
    this.setState({pageNow: page.selected + 1}, ()=> this.listGet())
  }

  paginateRender = () => {
    return <div className="uk-text-right">
      <ReactPaginate
        className={'uk-padding-remove'}
        previousLabel={'previous'}
        nextLabel={'next'}
        breakLabel={'...'}
        breakClassName={'break-me'}
        pageCount={this.state.pageAmount}
        marginPagesDisplayed={2}
        pageRangeDisplayed={5}
        onPageChange={this.handlePageClick}
        containerClassName={'pagination'}
        subContainerClassName={'pages pagination'}
        activeClassName={'active'}
      />
    </div>
  }

  componentDidMount() {
    this.listGet();
  } 

  render() {
    return <div className="uk-padding">
      <div className="uk-card uk-card-default uk-padding-small">
        <div className="d-card-header">
          <div uk-grid="">
            <div className='uk-width-1-2@m uk-width-1-1'>รายการแพ็คเกจ</div>
            <div className='uk-width-1-2@m uk-width-1-1 uk-text-right'>
              <a href={'/consult/packageOrderList'} >
              <button onClick={()=>this.packageAdd} className='uk-button uk-button-primary'>ใช้แพ็คเกจ</button>
              </a>
              <a href={'/consult/packageAdd'} >
              <button onClick={()=>this.packageAdd} className='uk-button uk-button-primary uk-margin-left'>เพิ่มแพ็คเกจ</button>
              </a>
              <button
                type='button'
                onClick={this.CsvExport}
                className='uk-button uk-button-primary uk-margin-left'
              >
                <span uk-icon='download'></span> ดาวน์โหลด XLSX
              </button>
            </div>
          </div>
        </div>
        <div className="uk-overflow-auto">
        <table className="uk-table uk-table-small uk-table-divider uk-table-striped">
            <thead>
              <tr>
                <th>ที่</th>
                <th>ชื่อแพ็คเกจ</th>
                <th>ราคา</th>
                <th>ใช้งาน</th>
                <th>วันหมดอายุ</th>
                <th>แก้ไข</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.loadingApi === true ?
                <tr>
                  <td colSpan="100%">
                    <div className="uk-padding-small uk-text-center"><span uk-spinner=""></span></div>
                  </td>
                </tr>
                :
                this.state.list.length === 0 ? 
                <tr>
                  <td colSpan="100%">
                    <div className="uk-padding-small uk-text-center">ไม่พบข้อมูล</div>
                  </td>
                </tr>
                :

                this.state.list.map((data, key)=>{

                  var _price = this.getDisplayPrice(data);

                  return <tr key={`row${data.id}`}>
                    <td>{(this.state.perPage * (this.state.pageNow-1 ) + key + 1)}</td>
                    <td>
                      {data.title}
                    </td>
                    <td>
                    ฿ {_price}
                    </td>
                    <td>{data.publish === "1" ? <span uk-icon="icon:check"></span> : ''}
                    </td>
                    <td>{data.expired_date && data.expired_date != '0000-00-00' ? moment(data.expired_date, 'YYYY-MM-DD').format("DD/MM/YYYY") : ''}
                    </td>
                    <td>
                      <a target="_blank" href={`/consult/packageAdd?id=${data.id}`}><span uk-icon="pencil"></span></a>
                    </td>
                  </tr>
                })
              }
            </tbody>
          </table>
          <div>
            {this.paginateRender()}
          </div>
          </div>
      </div>
    </div>
  }
};
